"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaptchaConfigV3 = void 0;
exports.CaptchaConfigV3 = {
    attSiteKeys: {
        siteKey: '6LdMeCIUAAAAAFHYMFkObspfKRx0nomc_jUooKnB',
        siteKeyV3: '6LeZpLgZAAAAANETaW8pbTYkKc9QUU60StgO_5EO',
    },
    personalSitekeys: {
        secretKey: '6LeXfpcUAAAAAMMu6-d3QwsLqSqvQ8KxQfQpIydR',
        siteKey: '6LeXfpcUAAAAALTB0vvp-tRX_3j3Rq56zW8TH6tC',
    },
    scoreUrl: "/msapi/captchams/v1/captcha/verify?version=v3",
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/CaptchaGeneratorV3/CaptchaGeneratorV3.config.js
// module id = 1751
// module chunks = 8